/**
 * @TODO rename this file to CMSTeaserRoleLogic.ts
 */

import { userHasMarkettingPermission, userIsCustomer, userIsLoggedIn } from "~/domains/user/utils/roles";
import { AccessLevel } from "~/features/cms/types/dto";

export interface checkIsLockedProps {
  gated?: boolean;
  marketingConsent?: boolean;
  accessLevel?: AccessLevel;
}

export const userGaveMarketingConsent = userHasMarkettingPermission();

/**
 * Sets the logic for the "locked / unlocked" state of the CMSTeaser
 */
export const checkIsLocked = ({ gated, marketingConsent, accessLevel }: checkIsLockedProps) => {
  if (!gated) {
    return false;
  }

  if (marketingConsent && !userHasMarkettingPermission()) {
    return true;
  }

  if (accessLevel === AccessLevel.business) {
    return !userIsCustomer();
  } else {
    return !userIsLoggedIn();
  }
};

export const checkIsVisible = () => {
  return !userIsLoggedIn();
};
